export class ButtonPlanToOrder {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-order-to-plan";
        this._container.innerHTML = `
            <button style="padding: 14px 12px;">
                <svg stroke="red" fill="#fff" stroke-width="0" viewBox="0 0 256 256" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg">
                    <path d="M228.61,60.16A6,6,0,0,0,224,58H61L54.63,22.93A6,6,0,0,0,48.73,18H24a6,6,0,0,0,0,12H43.72L69.53,171.94a21.93,21.93,0,0,0,6.24,11.77A26,26,0,1,0,113.89,190h52.22A26,26,0,1,0,188,178H91.17a10,10,0,0,1-9.84-8.21L77.73,150H196.1a22,22,0,0,0,21.65-18.06L229.9,65.07A6,6,0,0,0,228.61,60.16ZM106,204a14,14,0,1,1-14-14A14,14,0,0,1,106,204Zm96,0a14,14,0,1,1-14-14A14,14,0,0,1,202,204Zm3.94-74.21A10,10,0,0,1,196.1,138H75.55L63.19,70H216.81Z">
                    </path>
                </svg>
            </button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ShowBaseMapPicker {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-baseMap-switcher";
        this._container.innerHTML = `<button style="padding: 14px;"></button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class ButtonLayerPicker {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-layer-switcher";
        this._container.innerHTML = `<button style="padding: 14px;"></button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}


export class Button3D {
    constructor(onClick) {
        this.onClick = onClick;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
        this._container.innerHTML = `<button>3D</button>`;
        this._container.addEventListener("contextmenu", (e) => e.preventDefault());
        this._container.addEventListener("click", this.onClick);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}